import CardPage6 from "./cardpage6";
import Title6 from "./title6";

export default function Page6(){
    return(
    <>
    <Title6/>
    <CardPage6/>
    </>
    )
}